/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_0_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch GridCraft in the browser`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在浏览器中启动 GridCraft`)
};

/**
* | output |
* | --- |
* | "Launch GridCraft in the browser" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_title as "gc.search_guides.gridcraft_online.sections.0.title" }